<template>
    <v-card flat>
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-toolbar flat>
                        <v-file-input 
                            v-model="editItems.backupFilePath"
                            dense
                            clearable 
                            label="バックアップファイル" 
                            outlined 
                            hide-details
                            accept="text/*"
                            class="mr-1"
                            @change="onChangedFile" />
                        <v-btn color="primary" @click="onClickReadBackupFile" class="mr-1 ml-1" :disabled="editItems.backupFilePath == null">読取</v-btn>
                    </v-toolbar>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <v-card outlined>
                        <v-toolbar flat>
                            <v-btn color="primary" :disabled="selectedItems == null || selectedItems.length == 0" @click="onClickRestore" small>
                                <v-icon>mdi-restore</v-icon>
                                チェックされたドキュメントを復元
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="4">
                    <v-card outlined v-if="treeItems != null">
                        <v-btn-toggle v-model="treeSelectionType" class="ma-1">
                            <v-btn value="independent" small>
                                <v-icon>mdi-human-child</v-icon>単体
                            </v-btn>
                            <v-btn value="leaf" small>
                                <v-icon>mdi-human-male-child</v-icon>親子
                            </v-btn>
                        </v-btn-toggle>
                        <v-treeview 
                            ref="tree" 
                            v-model="selectedItems" 
                            :items="treeItems" 
                            dense 
                            selectable
                            :selection-type="treeSelectionType">
                            <template slot="label" slot-scope="data">
                                <v-chip label :color="data.selected ? 'yellow' : 'white'" @click="onClickTreeItem(data)">
                                    {{data.item.name}}
                                </v-chip>
                            </template>
                        </v-treeview>
                    </v-card>
                </v-col>
                <v-col cols="8" v-if="selectedItem != null">
                    <v-card outlined>
                        <v-card-text>
                            <table>
                                <tr>
                                    <td><v-chip label small class="mr-2">パス</v-chip>{{selectedItem.path}}</td>
                                </tr>
                                <template v-if="selectedItem.type == 'document'">
                                    <tr>
                                        <td>
                                            <tree-view :data="selectedItem.doc.data" />
                                        </td>
                                    </tr>
                                </template>
                            </table>                            
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>            
        </v-container>
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    export default {
        data: function () {
            return {
                editItems: {
                    backupFilePath: null
                },
                treeItems: null,
                createdItems: null,
                selectedItems: [],
                selectedItem: null,
                treeSelectionType: "independent"
            }
        },
        watch: {
            selectedItems: function (value, old) {
                const self = this
                value.forEach(function(v){
                    const item = self.createdItems.find((i)=>i.id == v)
                    if (item != null) {
                        console.log(v, item)
                    } else {
                        console.log(v, "unknown")
                    }
                })
            }
        },
        methods: {
            /**
             * 読取ボタン押下時
             */
            onClickReadBackupFile: function () {
                const self = this

                const reader = new FileReader()
                reader.readAsText(this.editItems.backupFilePath)
                reader.onload = function () {
                    const records = reader.result.split("\n")
                    const documents = []
                    records.forEach(function(record, index){
                        if (record != "") {
                            const doc = JSON.parse(record)
                            documents.push(
                                {
                                    path: doc.path.substr(1),
                                    pathList: doc.path.substr(1).split("/"),
                                    data: doc.data,
                                    item: null
                                }
                            )
                            console.log("document path", doc.path.substr(1))
                        }
                        if (index == records.length - 1) {
                            documents.sort(function(x, y){
                                if (x.path > y.path) return 1
                                if (x.path < y.path) return -1
                                return 0
                            })
                            self.createTreeItem(documents)
                        }
                    })
                }
            },
            /**
             * 復元ボタン押下時
             */
            onClickRestore: function () {
                const self = this
                const batch = db.batch()

                for (var i=0; i<this.selectedItems.length; i++) {
                    const itemID = this.selectedItems[i]
                    const item = this.createdItems.find((createdItem)=>createdItem.id == itemID)
                    if (item != null && item.type == "document") {
                        var ref = db
                        for (var j=0; j<item.doc.pathList.length; j+=2) {
                            ref = ref.collection(item.doc.pathList[j]).doc(item.doc.pathList[j+1])
                        }
                        console.log("復元対象", item, item.id, ref)
                        batch.set(ref, item.doc.data)
                    } else {
                        console.log("復元対象外(不明な項目もしくはコレクション", item)
                    }
                }
                batch.commit().then(function() {
                    self.$store.commit("notification", {message:"復元処理を終了しました。"})
                }).catch(function(error){
                    self.$store.commit("notification", {message:"復元処理に失敗しました。", isError:true})
                })
            },
            /**
             * ツリーの項目クリック時
             * item:{
             *     item: any
             *     leaf: boolean
             *     selected: boolean
             *     indeterminate: boolean
             *     active: boolean
             *     open: boolean
             * }
             */
            onClickTreeItem: function (item) {
                /** クリック箇所を選択もしくは選択解除 */
                // if (item.selected) {
                //     this.selectedItems.splice(this.selectedItems.findIndex((v)=>v == item.item.id), 1)
                // } else {
                //     this.selectedItems.push(item.item.id)
                // }
                // console.log(this.selectedItems)
                this.selectedItem = item.item
            },
            /**
             * ファイルが変更された時
             */
            onChangedFile: function () {
                console.log(this.editItems.backupFilePath)
            },
            /**
             * 指定された全ドキュメントが格納された配列から、ツリービューに設定する項目を作成
             */
            createTreeItem: function (documents) {
                const self = this

                this.treeItems = []
                this.createdItems = []

                documents.forEach(function(doc, index){

                    /** ドキュメントのアイテムを作成 */
                    const treeItem = {
                        id: doc.path,
                        name: doc.pathList[doc.pathList.length - 1],
                        type: "document",
                        path: doc.path,
                        doc: doc
                    }
                    doc.item = treeItem
                    self.createdItems.push(treeItem)

                    /** ドキュメントの親のパスを組み立て */
                    var parentPath = ""
                    for (var i=0; i<doc.pathList.length-1; i++) {
                        parentPath += ((i >0 ? "/" : "") + doc.pathList[i])
                    }

                    console.log("-------------------------")
                    console.log("document item", treeItem.id, "parent", parentPath)
                    
                    /** 親のアイテムを検索 */
                    const parentTreeItem = self.createdItems.find(function(item){
                        if (item.type == "collection" && item.path == parentPath) {
                            return item
                        }
                    })

                    if (parentTreeItem != null) {
                        /** 親が見つかった時は、その子として追加 */
                        console.log("parent find!", "parent", parentTreeItem.id)
                        if (parentTreeItem.children == null) {
                            parentTreeItem.children = []
                        }
                        parentTreeItem.children.push (treeItem)
                    } else {
                        console.log("parent not find!")
                        /** 親が見つからなかった時は、コレクションのアイテムを作成してドキュメントのアイテムを追加 */
                        const parentPathList = parentPath.split("/")
                        const treeCollectionItem = {
                            id: parentPath,
                            name: parentPathList[parentPathList.length - 1],
                            type: "collection",
                            path: parentPath,
                            children: [treeItem]
                        }
                        self.createdItems.push(treeCollectionItem)
                        console.log("created collection item", treeCollectionItem.id)

                        /** ルートコレクション以外であれば、コレクションの主となるドキュメントを検索 */
                        var parentDocPath = ""
                        for (var i=0; i<doc.pathList.length-2; i++) {
                            parentDocPath += ((i >0 ? "/" : "") + doc.pathList[i])
                        }
                        const parentDocument = self.createdItems.find(function(item){
                            if (item.type == "document" && item.path == parentDocPath) {
                                return item
                            }
                        })
                        /** ドキュメントが見つかれば、そのドキュメントのコレクションとして追加 */
                        if (parentDocument != null) {
                            console.log("collection parent document find!", parentDocument.id)
                            if (parentDocument.children == null) {
                                parentDocument.children = []
                            }
                            parentDocument.children.push(treeCollectionItem)
                        } else {
                            /** 見つからなかった時は、ルートに追加 */
                            console.log("collection parent document not find!")
                            self.treeItems.push(treeCollectionItem)
                        }
                    }
                    if (index == documents.length - 1) {
                        console.log(self.createdItems, self.treeItems)
                    }
                })
            },
        },
    }
</script>